module.exports = __webpack_public_path__ + "img/lr1.8a3cf8f6.png";